import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Utils from '../utils';
import { LegalList } from './LegalList.component';
import { TermsPage } from './TermsPage.component';

const { Logger, Session, Util } = Utils;

export const TermsWrapper = () => {
	const showAcceptCallback = success => {
		const { IsInWinClient, AllowedTargetOrigin } = Session.getSettings();

		if (IsInWinClient) {
			window.close();
		} else {
			try {
				Util.postMessage({ success, type: 'Terms' }, AllowedTargetOrigin);
			} catch (error) {
				Logger.logToServer({
					category: 'showaccept_error',
					error,
				});
				console.log(error);
			}
		}
	};

	return (
		<BrowserRouter basename={__BASENAME__}>
			<Switch>
				<Route exact path="/terms/legallist" component={LegalList} />
				<Route
					path="/terms/:termType"
					render={props => (
						<TermsPage {...props} callback={showAcceptCallback} />
					)}
				/>
			</Switch>
		</BrowserRouter>
	);
};
